module.exports = require('./wrapPromise')
